module.exports = __webpack_public_path__ + "img/traffic-junction-1.f735434e.jpg";